import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import BarChart from "../barChart";
import TabData from "./tabData";
import CalculateInequalityMeasures from "./calculateInequalityMeasures";

const currentIndicator = ({ filters }) => filters.get("disease");
const indicatorsMap = ({ filters }) => filters.get("indicators");

const dataSelector = createSelector(
  currentIndicator,
  indicatorsMap,
  (selected, map) => {
    return _.get(map, selected);
  }
);

function TabContainer(props) {
  return (
    <Typography
      component="div"
      style={{ padding: 8 * 3, textAlign: "justify" }}
    >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
});

class SimpleTabs extends React.Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, barChartRef, data } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Tabs value={value} onChange={this.handleChange}>
            <Tab label="Gráfico" />
            <Tab label="Generalidades" />
            <Tab label="Desigualdades" />
          </Tabs>
        </AppBar>
        {value === 0 && (
          <TabContainer>
            <BarChart parentNode={barChartRef} />
          </TabContainer>
        )}
        {value === 1 && (
          <TabContainer>
            <TabData data={_.get(data, "generalities", {})} />
          </TabContainer>
        )}
        {value === 2 && (
          <TabContainer>
            <TabData data={_.get(data, "inequalities", {})} />
            <CalculateInequalityMeasures/>
          </TabContainer>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: dataSelector(state)
  };
}

SimpleTabs.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(SimpleTabs);



// WEBPACK FOOTER //
// ./src/components/tabs/index.js